import SourceFlowImage from '@sourceflow-uk/sourceflowimage';
import { Container, Card } from 'reactstrap';
import Link from 'next/link';
import styles from './styles.module.scss';
import Arrow from '/public/site-assets/svg/black-arrow.svg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper';
import useNews from '@/hooks/useNews';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export const LatestNews = ({
  className,
  title,
  heading,
  content,
  buttonLink,
  buttonTitle,
  tags
}) => {

  const items = useNews({ filters: tags ?? null });

  if (!items || !items.length > 0) {
    return null;
  }

  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.swiper-custom-paginations .latestNewsSwiper`,
    },
    navigation: {
      nextEl: `.latestNewsSwiper.swiper-next`,
      prevEl: `.latestNewsSwiper.swiper-prev`,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  };

  return (
    <section className={`${styles.root} ${className} grayGradientBg top-rounded-radius`}>
      <Container className="py-4 py-md-5">
        {content &&
          <div className="text-center">
            {title &&
                <h2 className={`${heading} fw-bold`}>{title}</h2>
            }
            {content &&
                <div className="mb-4" dangerouslySetInnerHTML={{ __html: content }} />
            }
          </div>
        }
        {buttonLink && buttonTitle &&
          <div className="text-center mt-4">
            <Link href={buttonLink}>
              <a className="primaryBtn no-arrow m-0">
                {buttonTitle}
              </a>
            </Link>
          </div>
        }
        <div className="pt-5 position-relative">
          <div className="d-flex position-absolute swiperArrowWrapper">
            <button className="latestNewsSwiper arrow swiper-prev border-0 p-0" aria-label="Prev">
              <Arrow />
            </button>
            <button className="latestNewsSwiper arrow swiper-next border-0 ms-2 p-0" aria-label="Next">
              <Arrow />
            </button>
          </div>
          <Swiper {...settings}>
            {items?.map((item, index) => (
              <SwiperSlide key={index}>
                <Card className="overflow-hidden h-100">
                  <Link href={`/blog/${item?.url_slug}`}>
                    <a className="d-flex flex-wrap justify-content-between h-100">
                      <div className="position-relative ratio ratio-16x9">
                        <SourceFlowImage
                          src={item?.image ? item.image : '/site-assets/placeholders/img-placeholder.jpg'}
                          size="400x250"
                          alt={item?.title}
                          className="card-img rounded-0"
                          width="100%"
                          height="100%"
                        />
                        {item?.tag?.length >= 1 &&
                          <div className="position-absolute post-tag">
                            {item.tag?.map((tag, index) => (
                              <span className="tertiary-bg text-black d-inline-block px-2 rounded-3 me-2 mb-2" key={index}>
                                {tag}
                              </span>
                            ))}
                          </div>
                        }
                      </div>
                      <div className="conteWrapper p-3">
                        <div>
                          <p className="post-title">
                            <strong>{item?.title}</strong>
                          </p>
                          {item?.short_description &&
                            <p className="post-description">{item.short_description}</p>
                          }
                        </div>
                        <span>Read More</span>
                      </div>
                    </a>
                  </Link>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="text-center swiper-custom-paginations mt-4">
          <div className="latestNewsSwiper" />
        </div>
      </Container>
    </section>
  );
}

export default LatestNews;
